export default __webpack_public_path__ + "static/media/sid.png.webp";